export interface IUnlockedContent {
  contentUnlocked: string;
  unitName: string;
  unitDescription?: string;
  category: string;
  isUnlocked: boolean;
}

export class UnlockedContent implements IUnlockedContent {
  contentUnlocked: string;
  unitName: string;
  unitDescription?: string;
  category: string;
  isUnlocked: boolean;

  get week(): number {
    if (!this.unitDescription)
    {
      return 0;
    }
    const match = this.unitDescription!.match(/\bWeek\s+(\d+)\s*$/i);
    return match ? Number(match[1]) : 0;
  }
}
